import * as Types from "../schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DeleteResearchMutationVariables = Types.Exact<{
  research_id: Types.Scalars["Int"];
  upload_id?: Types.Maybe<Types.Scalars["uuid"]>;
}>;

export type DeleteResearchMutation = { __typename?: "mutation_root" } & {
  delete_research?: Types.Maybe<
    { __typename?: "research_mutation_response" } & Pick<
      Types.Research_Mutation_Response,
      "affected_rows"
    >
  >;
  delete_uploads?: Types.Maybe<
    { __typename?: "uploads_mutation_response" } & Pick<
      Types.Uploads_Mutation_Response,
      "affected_rows"
    >
  >;
};

export const DeleteResearchDocument = gql`
  mutation DeleteResearch($research_id: Int!, $upload_id: uuid) {
    delete_research(where: { id: { _eq: $research_id } }) {
      affected_rows
    }
    delete_uploads(where: { id: { _eq: $upload_id } }) {
      affected_rows
    }
  }
`;

export function useDeleteResearchMutation() {
  return Urql.useMutation<
    DeleteResearchMutation,
    DeleteResearchMutationVariables
  >(DeleteResearchDocument);
}
